<template>
  <channel-selector
    :class="{ inactive: !isActive }"
    :title="channel.name"
    :src="getChannelThumbnail()"
    @click="onItemClick"
  />
</template>
<script>
import ChannelSelector from '../ChannelSelector.vue';
export default {
  components: { ChannelSelector },
  props: {
    channel: {
      type: Object,
      required: true,
    },
    enabledFeatures: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isActive() {
      const { key } = this.channel;
      if (Object.keys(this.enabledFeatures).length === 0) {
        return false;
      }
      if (key === 'website') {
        return this.enabledFeatures.channel_website;
      }
      if (key === 'facebook') {
        return this.enabledFeatures.channel_facebook;
      }
      // d99d
      if (key === 'facebook2') {
        return this.enabledFeatures.channel_facebook;
      }
      // d99d 99hub — gated on the same Facebook feature flag as the legacy Meta channels
      if (
        ['hub_fb_page', 'hub_ig_page', 'hub_fb_messenger', 'hub_ig_messenger'].includes(key)
      ) {
        return this.enabledFeatures.channel_facebook;
      }
      // .
      if (key === 'email') {
        return this.enabledFeatures.channel_email;
      }

      return [
        'website',
        'twilio',
        'api',
        'whatsapp',
        'sms',
        'telegram',
        'line',
        'api_whatsapp_select',
        'api_sms',
        'tiktok',
        'api_incoming_calls',
      ].includes(key);
    },
  },
  methods: {
    getChannelThumbnail() {
      if (this.channel.key === 'api' && this.channel.thumbnail) {
        return this.channel.thumbnail;
      }
      // d99d
      if (this.channel.key.includes('whatsapp')) {
        return "/assets/images/dashboard/channels/whatsapp.png"
      }
      if (this.channel.key.includes('sms')) {
        return "/assets/images/dashboard/channels/sms.png"
      }
      if (this.channel.key === 'api_incoming_calls') {
        return "/assets/images/dashboard/channels/api_incoming_calls.png"
      }
      // .
      return `/assets/images/dashboard/channels/${this.channel.key}.png`;
    },
    onItemClick() {
      if (this.isActive) {
        this.$emit('channel-item-click', this.channel.key);
      }
    },
  },
};
</script>
